/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Akce',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Odeslat zpětnou vazbu',
  'ai-smart-button.ai-actions.help.section.text': 'Nápověda',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Připojit',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Zmínka',
  'ai-smart-button.ai-actions.input.send-button-label': 'Odeslat',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOVÉ',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Přidat ikonu',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Ikona automatizace',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatizace',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Procházet agenty',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Vytvořit automatizaci',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Dobrý den, {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Zavřít',
  'ai-smart-button.feedback-action.ask-question-option': 'Položit otázku',
  'ai-smart-button.feedback-action.cancel-button-label': 'Zrušit',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Vyberte jednu možnost.',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Popsat chybu nebo problém',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Dejte nám vědět, co si myslíte',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Co byste chtěli vědět?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Dejte nám vědět, co byste chtěli zlepšit',
  'ai-smart-button.feedback-action.feedback-modal-heading': 'Sdělte nám svůj názor',
  'ai-smart-button.feedback-action.leave-comment-option': 'Zanechat komentář',
  'ai-smart-button.feedback-action.report-bug-option': 'Ohlásit chybu',
  'ai-smart-button.feedback-action.research-participation-message': 'Chci se zúčastnit produktového průzkumu',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Vybrat zpětnou vazbu',
  'ai-smart-button.feedback-action.submit-button-label': 'Odeslat zpětnou vazbu',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Navrhnout zlepšení',
  'ai-smart-button.feedback-action.title': 'Odeslat zpětnou vazbu',
  'ai-smart-button.feedback-item.icon-label': 'Ikona zpětné vazby',
  'ai-smart-button.reference.close-button-label': 'Zavřít',
};
